var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1111 38.8889C41.1111 36.5314 42.0476 34.2705 43.7146 32.6035C45.3816 30.9365 47.6425 30 50 30C52.3575 30 54.6184 30.9365 56.2854 32.6035C57.9524 34.2705 58.8889 36.5314 58.8889 38.8889C58.8889 41.2464 57.9524 43.5073 56.2854 45.1743C54.6184 46.8413 52.3575 47.7778 50 47.7778C47.6425 47.7778 45.3816 46.8413 43.7146 45.1743C42.0476 43.5073 41.1111 41.2464 41.1111 38.8889ZM41.1111 52.2222C38.1643 52.2222 35.3381 53.3929 33.2544 55.4766C31.1706 57.5603 30 60.3865 30 63.3333C30 65.1014 30.7024 66.7971 31.9526 68.0474C33.2029 69.2976 34.8986 70 36.6667 70H63.3333C65.1014 70 66.7971 69.2976 68.0474 68.0474C69.2976 66.7971 70 65.1014 70 63.3333C70 60.3865 68.8294 57.5603 66.7456 55.4766C64.6619 53.3929 61.8357 52.2222 58.8889 52.2222H41.1111Z",
    fill: "#9A9EA5",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d1fd817a095f2c6e67cad79744137faf.svg";
export { ForwardRef as ReactComponent };